import React from "react";

import { Route, Routes } from "react-router-dom";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

//redux
import { useSelector } from "react-redux";
import { useEffect } from "react";
// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/index";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { createSelector } from "reselect";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";
import pageTitles from "./routes/pageTitle";
import { useThemeInitializer } from './common/useThemeInitializer';

// Activating fake backend
fakeBackend();

function getLayout(layoutType: string) {
  let layoutCls: Object = VerticalLayout;
  switch (layoutType) {
    case "horizontal":
      layoutCls = HorizontalLayout;
      break;
    default:
      layoutCls = HorizontalLayout;
      break;
  }
  return layoutCls;
}

const App = () => {

  const selectLayoutProperties = createSelector(
    (state:any) => state.Layout,
    (layout:any) => ({
      layoutType: layout.layoutType,
    })
  );

  // Inside your component
  const {
    layoutType
  } = useSelector(selectLayoutProperties);
  
  const location = useLocation();
  const currentPageName = pageTitles[location.pathname] || "Home";
  
  const Layout: any = getLayout(layoutType);

  const { agency } = useSelector((state: any) => state.agency);
  
  const agencyFavIcon = agency?.data?.agency_logo || "/favicon.png";

  const agencyName = agency?.data?.agency_name || "Q1Media";

  useEffect(() => {
    const updateFavicon = (iconUrl: string) => {
      let link: any = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = iconUrl;
    };

    if (agencyFavIcon) {
      updateFavicon(agencyFavIcon);
    }
    if (agencyName) {
      document.title = `${currentPageName} | ${agencyName}`;
    }
  }, [agencyFavIcon,agencyName,currentPageName]);


  useThemeInitializer(); // Applies themes before render

  return (
    <React.Fragment>
      <ToastContainer />
      <Routes>
        <Route>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  {route.component}
                </NonAuthLayout>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default App;
